import { BaseModel } from "sjs-base-model";
import CercaPreventiviTabellaModel from "./CercaPreventiviTabellaModel";

export default class CercaPreventiviFormModel extends BaseModel {
    public readonly denominazione: string = "";
    public readonly numSimulazione: string = "";
    public readonly numPratica: string = "";
    public readonly numPreventivo: string = "";
    public readonly agente: string = "";
    public readonly canale: string = "";
    public readonly segmento: string = "";
    public readonly tipoRichiesta: string = "";
    public readonly atc: string = "";
    public readonly tipoCliente: string = "";
    public readonly rata: string = "";
    public readonly durata: string = "";
    public readonly importo: string = "";
    public readonly dataCreazioneDa: string = "";
    public readonly dataCreazioneA: string = "";
    public readonly tipoProdotto: string = "";
    public readonly colName?: keyof CercaPreventiviTabellaModel = "idEstimate";
    public readonly direction?: undefined | "A" | "D" = undefined;
    public readonly firstName: string = "";
    public readonly lastName: string = "";
    public readonly idStatoPrev?: number = undefined;

    constructor(data: Partial<CercaPreventiviFormModel>) {
        super();

        this.update(data);
    }
}
